"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Model = void 0;
const getter_1 = require("../types/getter");
class Model {
    constructor(v = null) {
        var _a;
        this.setValue = (value) => {
            this._value = value;
        };
        this.reset = () => {
            this.setValue(getter_1.Getter.getValue(this._defaultValue));
        };
        this._value = (_a = getter_1.Getter.getValue(v)) !== null && _a !== void 0 ? _a : null;
        this._defaultValue = v;
    }
    get value() { return this._value; }
    set value(v) {
        this.setValue(v);
    }
}
exports.Model = Model;
//# sourceMappingURL=Model.js.map